import API from 'utils/api';
import getFormattedValues, { formatReceived } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/configuracion/depositos-bancario/';

/**
 * GET Depositos Bancarios
 * @returns {Promise<Array<object>>}
 */
export const getDepositosBancarios = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Deposito Bancario
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getDepositoBancario = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Deposito Bancario
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDepositoBancario = async (values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH  Deposito Bancario
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDepositoBancario = async (id, values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.patch(`${baseURI}/${id}`, formattedValues);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE  de Deposito Bancario
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteDepositoBancario = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
